module.exports = __webpack_public_path__ + "static/media/upload.90e69438.svg";